import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogContentText } from "@mui/material";
import { MuiButton } from "@ace/ace-ui-web";
import { motion } from "framer-motion";
import styles from "./postShift.module.css";

interface ConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    description: string;
    children: React.ReactNode;
    confirmLabel?: string;
    isSubmitting?: boolean;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    open,
    onClose,
    onConfirm,
    title,
    description,
    children,
    confirmLabel = "Confirm",
    isSubmitting = false,
}) => (
    <Dialog open={open} onClose={isSubmitting ? undefined : onClose}>
        <DialogContent className={styles.maxWLg}>
            <DialogTitle className={styles.modalTitle}>{title}</DialogTitle>
            <DialogContentText className={styles.modalDescription}>
                {description}
            </DialogContentText>
            <div className={styles.modalBody}>{children}</div>
            <div className={styles.modalFooter}>
                <div className={styles.buttonGroup}>
                    <motion.div
                        whileHover={isSubmitting ? undefined : { scale: 1.01 }}
                        whileTap={isSubmitting ? undefined : { scale: 0.99 }}
                        className={styles.buttonFull}
                        style={{ pointerEvents: isSubmitting ? 'none' : 'auto' }}
                    >
                        <MuiButton variant="outlined" onClick={onClose} disabled={isSubmitting} sx={{ width: '100%' }}>
                            Cancel
                        </MuiButton>
                    </motion.div>
                    <motion.div
                        whileHover={isSubmitting ? undefined : { scale: 1.01 }}
                        whileTap={isSubmitting ? undefined : { scale: 0.99 }}
                        className={styles.buttonFull}
                        style={{ pointerEvents: isSubmitting ? 'none' : 'auto' }}
                    >
                        <MuiButton onClick={onConfirm} disabled={isSubmitting} sx={{ width: '100%' }}>
                            {confirmLabel}
                        </MuiButton>
                    </motion.div>
                </div>
            </div>
        </DialogContent>
    </Dialog>
);